export class Message {
    public Command: string;
    public Parameters: any;

    constructor(command: string, parameters: any = {}) {
        this.Command = command;
        this.Parameters = parameters;
    }

    public toString(): string {
        return JSON.stringify(this);
    }

    public static parse(msgStr: string): Message {
        const msgObj = JSON.parse(msgStr);
        return new Message(msgObj.Command, msgObj.Parameters);
    }
}
